import React, { FC } from "react";
import EChartsReact from "echarts-for-react";
import { dataEntry, IDataTest } from "../../types/types";

import {
    Paper
} from "@material-ui/core";
import { trafficLight } from "../../theme";


interface IFMChartProps {
    data: any
}


const LineChart: FC<IFMChartProps> = ({ data }) => {

    let left = 75
    // if (data.title === 'Bar Chart') {
    //     left = 200;
    // }

    // const height = data.height ? data.height : "250px";


    const valueData = data.data.map((entry: any) => {
        return entry.value
    })

    const categoryData = data.data.map((entry: any) => {
        return entry.index
    })



    const getOption = () => {

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'none' // 'shadow' as default; can also be 'line' or 'shadow'
                },
                backgroundColor: 'rgba(255,255,255,0.7)',
            },
            title: {
                text: data.title,
                left: 'center',
                textStyle: {
                    color: 'black'
                }

            },
            toolbox: {
                show: true,
                top: 0,
                feature: {
                    saveAsImage: {
                        show: true,
                        pixelRatio: 4
                    },
                    dataView: {
                        show: true,
                        readOnly: false

                    }
                },

            },
            legend: {
                bottom: 'bottom'
            },
 

            grid: {
                left: left,
                right: '20',
                bottom: '60',
                top: '40',
                containLabel: false
            },
            xAxis: {
                // type: 'value',
                name: 'Order',
                nameGap: 25,
                nameLocation: 'middle',

                data : categoryData
            },
            yAxis: {
                // type: 'category',
                name: data.yAxisName,
                // data: data.description
            },
            series: [

                {
                    type: 'bar',
                    data: valueData,
                }
                    
            ]
        };
    }

    return (<>
        <div style={{ padding: "10px" }}>
            <Paper variant={"outlined"}>
                <EChartsReact option={getOption()} style={{ height: 300 }} />
            </Paper>
        </div>

    </>
    );
}

export default LineChart;
